import { Check } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const PackagesSection = ({ scrollToSection }) => {
  return (
    <section id="packages" className="py-24 bg-gradient-to-b from-rose-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-rose-500 text-sm font-medium tracking-wider uppercase mb-2">Pricing</p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-800 mb-4">Bridal Makeup Packages</h2>
          <p className="text-stone-600 max-w-2xl mx-auto">By Khushi - Featuring top-tier products from Makeup Forever, Fenty Beauty, NARS, Estée Lauder, Dior</p>
        </div>

        {/* Main Bridal Packages */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-16">
          <Card className="border-2 border-rose-200 hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-white">
            <CardContent className="p-8">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-semibold text-stone-800 mb-2">HD Bridal Makeup</h3>
                <div className="text-4xl font-bold text-rose-500 mb-2">₹22,000</div>
                <p className="text-stone-600">Per look</p>
              </div>
              <div className="space-y-3 mb-6">
                <div className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-rose-500 mt-0.5 flex-shrink-0" />
                  <p className="text-stone-600">Premium international brands: Makeup Forever, Fenty Beauty, NARS, Estée Lauder, Dior</p>
                </div>
                <div className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-rose-500 mt-0.5 flex-shrink-0" />
                  <p className="text-stone-600">Complete HD bridal makeup</p>
                </div>
                <div className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-rose-500 mt-0.5 flex-shrink-0" />
                  <p className="text-stone-600">Professional hairstyling & draping</p>
                </div>
                <div className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-rose-500 mt-0.5 flex-shrink-0" />
                  <p className="text-stone-600">Eyelashes & colored contact lenses</p>
                </div>
              </div>
              <Button onClick={() => scrollToSection('contact')} className="w-full bg-rose-500 hover:bg-rose-600 text-white transition-all duration-300">
                Book Now
              </Button>
            </CardContent>
          </Card>

          <Card className="border-2 border-rose-300 hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-gradient-to-br from-white to-rose-50 relative overflow-hidden">
            <div className="absolute top-4 right-4 bg-rose-500 text-white text-xs font-bold px-3 py-1 rounded-full">PREMIUM</div>
            <CardContent className="p-8">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-semibold text-stone-800 mb-2">Airbrush Bridal Makeup</h3>
                <div className="text-4xl font-bold text-rose-500 mb-2">₹25,000</div>
                <p className="text-stone-600">Per look</p>
              </div>
              <div className="space-y-3 mb-6">
                <div className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-rose-500 mt-0.5 flex-shrink-0" />
                  <p className="text-stone-600">Professional airbrush makeup for flawless finish. I use TEMPTU Airbrush kit.</p>
                </div>
                <div className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-rose-500 mt-0.5 flex-shrink-0" />
                  <p className="text-stone-600">Long-lasting & camera-ready</p>
                </div>
                <div className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-rose-500 mt-0.5 flex-shrink-0" />
                  <p className="text-stone-600">Premium hairstyling & draping</p>
                </div>
                <div className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-rose-500 mt-0.5 flex-shrink-0" />
                  <p className="text-stone-600">Eyelashes & colored contact lenses</p>
                </div>
              </div>
              <Button onClick={() => scrollToSection('contact')} className="w-full bg-rose-500 hover:bg-rose-600 text-white transition-all duration-300">
                Book Now
              </Button>
            </CardContent>
          </Card>
        </div>

        {/* Look Change Charges */}
        <div className="bg-rose-50 rounded-2xl p-8 max-w-3xl mx-auto mb-16 border border-rose-200">
          <h3 className="text-2xl font-semibold text-stone-800 mb-6 text-center">Optional Add-Ons</h3>
          <div className="space-y-4">
            <div className="bg-white p-4 rounded-lg">
              <p className="text-stone-800 font-medium mb-2">Look Change Charges:</p>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="flex justify-between items-center">
                  <span className="text-stone-600">HD Makeup Look Change</span>
                  <span className="font-semibold text-rose-500">₹8,000</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-stone-600">Airbrush Look Change</span>
                  <span className="font-semibold text-rose-500">₹10,000</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Sider's Package */}
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-serif font-bold text-stone-800 mb-4">Sider's Package</h3>
            <p className="text-stone-600">For Bridesmaids, Family Members, or Special Guests</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <Card className="border border-rose-200 hover:shadow-xl transition-all duration-300">
              <CardContent className="p-6">
                <div className="text-center mb-4">
                  <h4 className="text-xl font-semibold text-stone-800 mb-2">HD Makeup</h4>
                  <div className="text-3xl font-bold text-rose-500">₹7,000</div>
                  <p className="text-stone-600 text-sm">Per look</p>
                </div>
                <div className="space-y-2">
                  <p className="text-stone-600 text-sm">Using premium international brands: Makeup Forever, Fenty Beauty, NARS, Estée Lauder, Dior</p>
                </div>
                <Button onClick={() => scrollToSection('contact')} className="w-full mt-4 bg-rose-500 hover:bg-rose-600 text-white transition-colors">
                  Book Now
                </Button>
              </CardContent>
            </Card>

            <Card className="border border-rose-200 hover:shadow-xl transition-all duration-300">
              <CardContent className="p-6">
                <div className="text-center mb-4">
                  <h4 className="text-xl font-semibold text-stone-800 mb-2">Airbrush Makeup</h4>
                  <div className="text-3xl font-bold text-rose-500">₹12,000</div>
                  <p className="text-stone-600 text-sm">Per look</p>
                </div>
                <div className="space-y-2">
                  <p className="text-stone-600 text-sm">Professional airbrush finish with premium products. Airbrush kit details can be found at <a href="https://temptu.com/">https://temptu.com</a></p>
                </div>
                <Button onClick={() => scrollToSection('contact')} className="w-full mt-4 bg-rose-500 hover:bg-rose-600 text-white transition-colors">
                  Book Now
                </Button>
              </CardContent>
            </Card>
          </div>

          <div className="bg-white rounded-2xl p-6 mt-8 shadow-md border border-rose-100">
            <h4 className="text-lg font-semibold text-stone-800 mb-4">What's Included:</h4>
            <div className="grid md:grid-cols-2 gap-3">
              <div className="flex items-start space-x-2">
                <Check className="w-5 h-5 text-rose-500 mt-0.5 flex-shrink-0" />
                <p className="text-stone-600">One complete look (HD or Airbrush)</p>
              </div>
              <div className="flex items-start space-x-2">
                <Check className="w-5 h-5 text-rose-500 mt-0.5 flex-shrink-0" />
                <p className="text-stone-600">Makeup, Hairstyling, and Draping</p>
              </div>
              <div className="flex items-start space-x-2">
                <Check className="w-5 h-5 text-rose-500 mt-0.5 flex-shrink-0" />
                <p className="text-stone-600">Use of international cosmetic brands</p>
              </div>
              <div className="flex items-start space-x-2">
                <Check className="w-5 h-5 text-rose-500 mt-0.5 flex-shrink-0" />
                <p className="text-stone-600">Hair Accessories or Fresh Flowers</p>
              </div>
              <div className="flex items-start space-x-2">
                <Check className="w-5 h-5 text-rose-500 mt-0.5 flex-shrink-0" />
                <p className="text-stone-600">Eyelashes and Colored Contact Lenses</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PackagesSection;